/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { CoreErrorKey } from '../key/core-error.key';
import { ApplicationError } from '../model/application-error.model';
import { IndexValueIterator } from '../util/index-value-iterator.util';
import { ObservableCollection } from '../util/observable-collection.util';

export function toEntries<K extends string | number, V>(
  source: Iterable<V> | Map<K, V> | ObservableCollection<K, V> | object
): Iterable<[K, V]> {
  if (source === undefined || source === null) {
    throw new ApplicationError({
      key: CoreErrorKey.SOURCE_MISSING,
      arguments: { source }
    });
  }
  if (typeof source !== 'object') {
    throw new ApplicationError({
      key: CoreErrorKey.SOURCE_INVALID,
      arguments: { source }
    });
  }
  // if (Array.isArray(source) || source instanceof Map || source instanceof ObservableCollection) {
  //   return source.entries() as IterableIterator<[K, V]>;
  // }
  if (typeof source['entries'] === 'function') {
    return source['entries']() as Iterable<[any, V]>;
  }
  if (source[Symbol.iterator]) {
    return new IndexValueIterator<V>(source[Symbol.iterator]()) as Iterable<[any, V]>;
  }
  // Object.entries is not available in IE 11
  const entries: Array<[string | number, any]> = typeof Object.entries === 'function'
    ? Object.entries(source)
    : Object.keys(source).map((key) => [key, source[key]]);
  return entries[Symbol.iterator]() as Iterable<[any, V]>;
}
